import { z } from 'zod';

export const cartItemInputSchema = z.object({
    productPriceId: z.string().uuid(),
});

export type СartItemInputSchema = z.infer<typeof cartItemInputSchema>;
